import React from 'react';

function Ref(props) {
  return (
    <div className="grow m-1">
      <img src={props.src} alt="" />
    </div>
  );
}

export default Ref;
